<ejs-treeview
  #treeview
  [fields]="fields"
  [showCheckBox]="true"
  (nodeChecked)="onNodeChecked($event)"
></ejs-treeview>
